import { FormattedMessage, useIntl } from 'react-intl'
import urls from '@app/routes/urls'
import useCampaignHref from '@app/hooks/useCampaignHref'
import Button from '../Button'
import S from './Faq.styles'

const Faq = () => {
  const { messages } = useIntl()
  const { href: faqUrl } = useCampaignHref({ requestPath: urls.faqs })

  return (
    <S.Wrapper>
      <S.Content>
        <img src={messages['faq_banner.content.image'] as string} alt="" />
        <FormattedMessage id="faq_banner.content.title" tagName="h4" />
        <Button to={faqUrl} color="white">
          <FormattedMessage id="faq_banner.content.button_text" />
        </Button>
      </S.Content>
    </S.Wrapper>
  )
}

export default Faq
